import { Observable, Observer, TeardownLogic } from 'rxjs';

export function blobToBase64(blob: Blob): Observable<string> {
  const subscribe = (observer: Observer<string>): TeardownLogic => {
    const reader = new FileReader();
    reader.onload = () => {
      const readerResult = reader.result;
      const base64 =
        typeof readerResult === 'string'
          ? readerResult.split(',')[1]
          : undefined;
      if (typeof base64 === 'string') {
        observer.next(base64);
        observer.complete();
      } else {
        observer.error('Cannot encode blob as base64');
      }
    };
    reader.onerror = () => observer.error('Cannot encode blob as base64');
    reader.readAsDataURL(blob);
  };
  return new Observable(subscribe);
}
